import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EPackageCouponEffectSortField,
  IPackageCouponEffect,
  PPackageCouponEffectFilter,
} from "src/core/packageCouponEffect/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IPackageCouponEffectState {
  packageCouponEffects: IPackageCouponEffect[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IPackageCouponEffectState = {
  packageCouponEffects: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "package-coupon-effect/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "package-coupon-effect/FETCH_SUCCEEDED";
const FETCH_FAILED = "package-coupon-effect/FETCH_FAILED";
const POLLING_START_REQUESTED = "package-coupon-effect/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "package-coupon-effect/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IPackageCouponEffect[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PPackageCouponEffectFilter;
    pagination: IPagination;
    sorts: ISort<EPackageCouponEffectSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IPackageCouponEffectState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IPackageCouponEffectState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.packageCouponEffects = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
